import { Row, Button, Form } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import DynamicField from "./fields/DynamicField";
import CustomCollapse from "../../../../../components/generic/CustomDetails";

const FormSection = ({ section, disabled = false, showHints = true }) => {
  return (
    <div className="form-section">
      <CustomCollapse
        open
        className="section-card"
        title={`${section.icon_emoji} ${section.label}`}
      >
        {section.is_repeating ? (
          <Form.List name={section?.id}>
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }, i) => (
                  <>
                    <div
                      key={key}
                      className={`repeating-instance ${
                        i === 0 ? "first-instance" : ""
                      }`}
                    >
                      <div className="instance-header">
                        <div className="instance-label">
                          {section.instance_label_template?.replace(
                            "{index}",
                            i + 1,
                          ) || `Instance ${i + 1}`}

                          {i === 0 && section?.first_instance_badge && (
                            <span className="instance-badge">
                              {section.first_instance_badge}
                            </span>
                          )}
                        </div>

                        {(!section.min_instances ||
                          fields.length > section.min_instances) && (
                          <div className="instance-actions">
                            <Button
                              type="text"
                              danger
                              size="small"
                              icon={<DeleteOutlined />}
                              onClick={() => remove(name)}
                              title="Remove instance"
                            />
                          </div>
                        )}
                      </div>

                      <Row gutter={[10, 0]}>
                        {section?.fields?.map((field) => (
                          <DynamicField
                            key={`${field.field_key}_${key}`}
                            field={{
                              ...field,
                              field_key: [name, field.field_key],
                            }}
                            disabled={disabled}
                            showHints={showHints}
                            restField={restField}
                          />
                        ))}
                      </Row>
                    </div>
                  </>
                ))}
                {(!section.max_instances ||
                  fields.length < section.max_instances) && (
                  <div className="repeating-actions">
                    <Button
                      type="dashed"
                      icon={<PlusOutlined />}
                      onClick={() => add()}
                      className="add-instance-btn"
                    >
                      Add{" "}
                      {section.instance_label_template?.replace(
                        " {index}",
                        "",
                      ) || "Instance"}
                    </Button>
                  </div>
                )}
              </>
            )}
          </Form.List>
        ) : (
          <Row gutter={[10, 0]}>
            {section?.fields?.map((field) => (
              <DynamicField
                key={field.field_key}
                field={field}
                disabled={disabled}
                showHints={showHints}
                section_id={section?.id}
              />
            ))}
          </Row>
        )}
      </CustomCollapse>
    </div>
  );
};

export default FormSection;
